module.exports = __webpack_public_path__ + "9f4117ef8ddc5474bd9f53874fb099ae.svg";